import React, { Component } from 'react'
import Translation from '../../../Translation/cont/Translation'
import TranslationTime from '../../../Translation/cont/TranslationTime'
import TranslationShowtime from '../../../Translation/cont/TranslationShowtime'
import SearchInput from '../../../general/SearchInput'

function toDateObj(timeUtc) {
    const num = Number(timeUtc)
    return new Date(isNaN(num) ? timeUtc : num)
}

class PerformancePickerDialog extends Component {
    constructor(props) {
        super(props)
        this.state = { pendingId: props.selectedId || null, search: '' }
    }

    getFilteredPerformances() {
        const { performances, movieId } = this.props
        if (!performances) return []
        const search = this.state.search.toLowerCase()
        const list   = Array.isArray(performances) ? performances : Object.values(performances)
        return list.filter(p => {
            if (movieId && String(p.cliMoviePk) !== String(movieId)) return false
            if (search) {
                const text = toDateObj(p.timeUtc).toLocaleString().toLowerCase()
                if (!text.includes(search)) return false
            }
            return true
        })
    }

    groupByDate(performances) {
        return performances.reduce((groups, perf) => {
            const dayKey = toDateObj(perf.timeUtc).toISOString().slice(0, 10)
            if (!groups[dayKey]) groups[dayKey] = []
            groups[dayKey].push(perf)
            return groups
        }, {})
    }

    render() {
        const { onSelect, onCancel } = this.props
        const { pendingId, search }  = this.state
        const groups = this.groupByDate(this.getFilteredPerformances())

        return (
            <div className="dialog-overlay" onClick={onCancel}>
                <div className="dialog dialog--tall" onClick={e => e.stopPropagation()}>
                    <div className="dialog-header">
                        <span className="dialog-title text-small-regular"><Translation id="social_media_select_performance_title" /></span>
                    </div>
                    <div className="dialog-search">
                        <SearchInput
                            placeholderTransId="social_media_search_performance_placeholder"
                            value={search}
                            onChange={val => this.setState({ search: val })}
                            autoFocus
                        />
                    </div>
                    <div className="dialog-body dialog-body--scroll dialog-body--padded">
                        {Object.keys(groups).length === 0 && (
                            <p className="dialog-empty"><Translation id="social_media_no_performances" /></p>
                        )}
                        {Object.entries(groups).map(([dayKey, perfs]) => (
                            <div key={dayKey} className="perf-picker-group">
                                <div className="perf-picker-date-label text-xsmall-light">
                                    <TranslationTime id="dateWithDay" timeString={perfs[0].timeUtc} />
                                </div>
                                <div className="perf-picker-times">
                                    {perfs.map(perf => {
                                        const id         = String(perf.id || perf.pk)
                                        const isSelected = pendingId === id
                                        return (
                                            <div key={id}
                                                className={`perf-picker-time-chip${isSelected ? ' perf-picker-time-chip--selected' : ''}`}
                                                onClick={() => this.setState({ pendingId: id })}>
                                                <TranslationShowtime string={perf.timeUtc} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="dialog-footer">
                        <button className="dlg-btn-cancel" onClick={onCancel}><Translation id="cancel_button" /></button>
                        <button className="dlg-btn-ok" disabled={!pendingId}
                            onClick={() => pendingId && onSelect(pendingId)}>
                            <Translation id="apply_button" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default PerformancePickerDialog
